import get from 'lodash-es/get';
import { useSelector } from 'react-redux';

import { BundleSection } from '@/modules/tryIt/components/BundleSection/BundleSection';
import TagsSection from '@/modules/tryIt/components/TagsSection/TagsSection';
import { VariablesSection } from '@/modules/tryIt/components/VariablesSection/VariablesSection';
import { selectCanEdit, selectTurnContext, selectTurnTags } from '@/modules/tryIt/redux/selectors';

const ContextSection = () => {
  const canEdit = useSelector(selectCanEdit);
  const contextTags = useSelector(selectTurnTags);
  const context = useSelector(selectTurnContext);

  const bundle = get(context, 'global.bundle', null);

  return (
    <>
      {/* CONTEXT BUNDLE SECTION */}
      <BundleSection canEdit={canEdit} bundle={bundle} />

      {/* CONTEXT VARIABLES SECTION */}
      <VariablesSection canEdit={canEdit} />

      {/* TAGS SECTION */}
      {<TagsSection canEdit={canEdit} tags={contextTags} />}
    </>
  );
};

export default ContextSection;
